import type { AnchorHTMLAttributes, ButtonHTMLAttributes, MutableRefObject, PropsWithChildren } from 'react';
import { createElement } from 'react';

import classNames from 'classnames';
import type { LocationDescriptor } from 'history';
import type { Link } from 'react-router-dom';

import styles from './styles.module.scss';

interface StaticCardItemProps
  extends PropsWithChildren<{
    addTopMarginToAllCards?: boolean;
    bind?: { ref: MutableRefObject<any> };
    className?: string;
    dataTestid?: string;
    fullWidthCard?: boolean;
    highlighted?: boolean;
    id?: string;
    inactive?: boolean;
    noDivider?: boolean;
    style?: 'white' | 'blue' | 'green' | 'red';
    tag?: string;
  }> {}

interface CardItemButtonProps {
  tag: 'button';
  onClick: ButtonHTMLAttributes<HTMLButtonElement>['onClick'];
}

interface CardItemAnchorProps {
  tag: 'a';
  href: string;
  onClick?: AnchorHTMLAttributes<HTMLAnchorElement>['onClick'];
}

interface CardItemLinkProps {
  tag: typeof Link;
  to: LocationDescriptor<unknown>;
  onClick?: AnchorHTMLAttributes<HTMLAnchorElement>['onClick'];
}

export type CardItemProps = StaticCardItemProps &
  (
    | CardItemButtonProps
    | CardItemAnchorProps
    | CardItemLinkProps
    | { tag?: string; [key: `data-${string}`]: boolean | string }
  );

export const Card = ({
  children,
  className,
  fullWidthCard,
  style = 'white',
  id,
  addTopMarginToAllCards,
  bind,
  dataTestid,
}: CardItemProps) => {
  return (
    <div
      id={id}
      className={classNames(
        addTopMarginToAllCards ? styles.marginOnAll : styles.regularCapsuleCard,
        { [styles.fullWidth]: fullWidthCard },
        styles.capsuleCard,
        styles.cardContainer,
        className,
        styles[style]
      )}
      data-testid={dataTestid}
      {...bind}
    >
      {children}
    </div>
  );
};

export const CardItem = ({
  children,
  className,
  highlighted,
  inactive,
  noDivider,
  tag = 'div',
  ...rest
}: CardItemProps) => {
  const attributes = {
    className: classNames(styles.cardItem, className, {
      [styles.highlighted]: highlighted,
      [styles.inactive]: inactive,
      [styles.noDivider]: noDivider,
    }),
    ...rest,
  };

  // @ts-ignore
  return createElement(tag, attributes, children);
};
